// LIBRARIES
import styled, { css } from "styled-components";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const TextEditorContainer = styled.div``;

export const LabelContainer = styled.p(
  ({ labelColor }) => css`
    font-size: 16px;
    font-family: ${FONTS.montserrat};
    font-weight: 600;
    color: ${labelColor ? labelColor : COLORS.secondaryBlack};
    margin-bottom: 7px;
  `
);

export const Container = styled.div`
  border: 1px solid #6c9efc;
  border-radius: 10px;
`;
